import PropTypes from 'prop-types';

const COLOR_VARIANTS = {
    gray: 'bg-gray-100',
    blue: 'bg-blue-100',
    green: 'bg-green-100',
    yellow: 'bg-yellow-100',
    red: 'bg-red-100',
    indigo: 'bg-indigo-100',
    purple: 'bg-purple-100',
    pink: 'bg-pink-100',
    sky: 'bg-sky-100',
    orange: 'bg-orange-100',
};

const ColorCard = ({ backgroundColor, title, description, children }) => {
    const backgroundClass = COLOR_VARIANTS[backgroundColor];

    return (
        <div
            className="bg-white border border-gray-300 rounded-lg shadow-sm overflow-hidden"
            role="region"
            aria-label={`${title} section`}
        >
            <div className={`${backgroundClass} border-b border-gray-300 px-6 py-4`}>
                <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
                <p className="text-sm text-gray-600 mt-1">{description}</p>
            </div>
            <div className="p-6">{children}</div>
        </div>
    );
};

ColorCard.propTypes = {
    backgroundColor: PropTypes.oneOf([
        'gray',
        'blue',
        'green',
        'yellow',
        'red',
        'indigo',
        'purple',
        'pink',
        'sky',
        'orange',
    ]).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default ColorCard;
